export const ADD = (state, value) => {
  state.list.push(value)
}

export const EDIT = (state, { index, value }) => {
  state.list.splice(index, 1, value)
}

export const REMOVE = (state, index) => {
  state.list.splice(index, 1)
}

export const SET_LIST = (state, value) => {
  state.list = value
}
